const T = {
  FIXED_TIMESTEP: 0.02,
  DEFAULT_DELTA: 0.006944444444444444
}, E = 4294967295;
export {
  E as NULL_ENTITY,
  T as TIME_CONSTANTS
};
//# sourceMappingURL=constants.js.map
